<template>
  <div class="section-main__warp carPatrolBlack-container buildingM">
    <div class="right-content"
         style="display:flex;flex-flow: column;">
      <div class="header-contnet">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-button type="primary"
                       style="padding:7px 13px"
                       @click="()=>{$router.go(-1)}">
              <i class="iconfont icon-iconfontfanhui"></i>
              返回
            </el-button>
            <el-button type="primary"
                       style="padding:7px 13px"
                       @click="createNameList">
              <i class="iconfont icon-xinzeng"></i>
              新增
            </el-button>
          </el-col>
          <el-col :span="12"
                  style="text-align:left;font-size:17px;line-height:30px">
            <span>
              【{{this.$route.query.name}}】楼层信息
            </span>
          </el-col>
        </el-row>
      </div>
      <div class="main-content"
           style="position:relative;">
        <el-row>
          <el-col :span="6">
            <div style="display:flex;align-items:center;">
              <div style="margin-right:8px">楼层名称:</div>
              <div style="flex:1;margin-right:8px">
                <el-input placeholder="请输入楼层名称"
                          v-model="filterData.name"></el-input>
              </div>
            </div>
          </el-col>
          <el-col :span="2">
            <div style="display:flex;align-items:center;">
              <div style="flex:1;padding-right:8px">
                <el-button type="primary"
                           @click="queryFilter">
                  查询
                </el-button>
              </div>
              <div style="flex:1">
                <el-button type="info"
                           @click="resetClick()">
                  重置
                </el-button>
              </div>
            </div>
          </el-col>
        </el-row>

        <div class="data-content"
             v-if="!loading">
          <div v-if="listData && listData.length"
               class="list-content">
            <el-scrollbar style="height:90%;position:absolute;width:100%">
              <div v-for="(item, index) in listData"
                   :key="index"
                   class="list-item">
                <div class="imgDiv">
                  <!-- left -->
                  <div class="itemLeft">
                    <img :src="imgPath(item)"
                         class="image"
                         onerror="this.src='/images/theme/newDark/default.png'"
                         @click="showViewer($event)" />
                  </div>
                  <!-- right -->
                  <div class="itemRight">
                    <div class="footer-content">
                      <el-button type="primary"
                                 @click="updateClick(item,'view')"
                                 title="详情">
                        <i class="el-icon-view"></i>
                      </el-button>
                      <el-button type="primary"
                                 @click="updateClick(item,'edit')"
                                 title="编辑">
                        <i class="el-icon-edit"></i>
                      </el-button>
                      <el-button type="primary"
                                 @click="deleteClick(item)"
                                 title="删除">
                        <i class="el-icon-delete"></i>
                      </el-button>
                    </div>
                    <div class="itemName">
                      <span>{{item.buildingName }}</span>
                    </div>
                    <div style="margin-top:30px">
                      <div class="itemItem">
                        <label>楼层所属模型链接</label>
                      </div>
                      <div class="itemItem">
                        <span :title="item.belongModelUrl ">{{item.belongModelUrl}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-scrollbar>

          </div>
          <!-- 暂无数据 -->
          <dataEmpty v-else />
        </div>
        <div class="loading-content"
             v-loading="true"
             style="line-height: 300px;"
             v-else></div>
      </div>
      <!-- 有数据时的页码 -->
      <div class="page-content paging"
           :style="!listData.length">
        <el-pagination background
                       :page-sizes="[10, 20, 30, 40, 50, 100]"
                       :page-size="pageObj.pageSize"
                       @current-change="currentChange"
                       @size-change="sizeChange"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pageObj.total">
        </el-pagination>
      </div>
    </div>

    <!--新增修改 名单表单 -->
    <el-dialog :title="formState === 1 ? '新增楼层' :formState === 2? '编辑楼层信息':'楼层详情'"
               :visible.sync="listFormShow"
               width="800px"
               @close="cancelListForm"
               :close-on-click-modal="false">
      <el-form :inline="true"
               ref="ruleForm"
               label-width="130px"
               :model="formData"
               :rules="rules"
               :status-icon="true">

        <el-form-item label="楼层名称"
                      style="width: 100%;"
                      prop="buildingName">
          <el-input v-model="formData.buildingName"
                    :maxlength="15"
                    placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="楼层所属模型链接"
                      prop="belongModelUrl">
          <el-input type="textarea"
                    autosize
                    clearable
                    :disabled="formState==3"
                    placeholder="请输入链接地址"
                    v-model="formData.belongModelUrl"
                    style="width:540px"></el-input>
        </el-form-item>
        <el-form-item label="楼栋CAD图纸"
                      style="width: 100%;"
                      prop="isVisible">
          <el-upload action="common/file/batchFileload.json"
                     class="el-upload-single"
                     :file-list="fileList"
                     ref="addAvatar"
                     v-show="formState!=3"
                     :multiple="false"
                     name="files"
                     :show-file-list="true"
                     :list-type="'picture-card'"
                     accept="image/png, image/jpg, image/jpeg, image/bpm"
                     :auto-upload="true"
                     :limit="1"
                     :before-upload="beforeAvatarUpload"
                     :on-success="handleSuccess"
                     :on-change="handleChangeFile"
                     :on-remove="handleRemove"
                     :on-exceed="handleExceed">
            <i class="el-icon-plus"></i>
          </el-upload>
          <img :src="imgPath(formData)"
               v-if="formState==3"
               class="img-content"
               style=" width: 200px;height: 200px;object-fit: fill;"
               @click="showViewer($event)"
               onerror="this.src='/images/theme/newDark/default-drawing1.jpg'" />
        </el-form-item>

      </el-form>
      <span slot="footer"
            v-if="formState!=3"
            class="dialog-footer">
        <el-button @click="cancelListForm"
                   :loading="subBtm">
          {{subBtm?'提交中':"取消"}}
        </el-button>
        <el-button type="primary"
                   :loading="subBtm"
                   @click="submitClick">
          {{subBtm?'提交中':"确定"}}
        </el-button>
      </span>
    </el-dialog>
    <viewer @inited="inited"
            :images="viewerPhotos"
            class="viewer"
            ref="viewer">
      <img v-for="src in viewerPhotos"
           :src="src"
           :key="src" />
    </viewer>
  </div>
</template>

<script>
import { api } from '../api'
import utils from '@src/common/utils'
import { Dic, Bus, Dates } from '$utils'
import i18n from '@src/common/lib/i18n'
import dataEmpty from '@src/components/common/ioc-component/app-data-empty.vue'
export default {
  components: {
    dataEmpty,
  },
  filters: {
    cradTypeFilter (el) {
      return Dic.findByValue('SENU028', el) || i18n.t('personMg.label.IDNo')
    },

  },
  data () {
    return {
      subBtm: false,
      viewerInstance: null,
      viewerPhotos: [],
      fileList: [], // 上传图片数组
      pageObj: {
        // 分页数据
        pageNum: 1,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10,
        total: 0,
      },
      formState: 1, // 1：新增 2：修改
      listFormShow: false, // 新增修改弹窗
      // 查询结果
      listData: [],
      // 过滤表单数据
      filterData: {
        name: '',
      },
      // 新增修改表单数据
      formData: {
        buildingName: '',
        belongModelUrl: "",
        fileCode: "",
        buildingCode: ""
      },
      rules: {
        buildingName: [
          { required: true, message: '请输入楼栋名称' },
          { max: 100, message: '长度10个字符', trigger: 'blur' },
        ],
      },
      isIndeterminate: false,
      listCodes: [], // 选中名单数组
      loading: false,
    }
  },
  watch: {
    fileList: {
      handler (newValue, oldValue) {
        this.formData.fileList = newValue
      },
      deep: true,
    },
  },
  mounted () {
    this.getListData()
  },
  methods: {
    resetListForm () {
      this.$refs['ruleForm'].resetFields()
      this.fileList = []
      this.formData.buildingName = ''
      this.formData.belongModelUrl = ''
      this.formData.fileCode = ''
    },
    imgPath (item) {
      return item ? Bus.imgPath(item.fileCode) : ''
    },
    showViewer (e) {
      this.viewerPhotos = [e.target.src.indexOf('default/default.png') == -1 ? e.target.src + "&sourceFileFlag=1" : e.target.src];
      this.viewerInstance.show()
    },
    inited (viewer) {
      this.viewerInstance = viewer
    },

    // 批量删除
    batchDelete (data) {
      this.$confirm("此操作将永久删除该数据, 是否继续", "提示", {
        confirmButtonText: this.$t('personMg.button.confirm'),
        cancelButtonText: this.$t('personMg.button.cancel'),
        type: 'warning',
      }).then((res) => {
        this.$fetch(api.deleteBuilding, {
          buildingCode: data ? data.buildingCode : this.listCodes,
        }).then((res) => {
          if (res.success) {
            this.$message.success("删除成功")
            !data ? this.listCodes = [] : ""
            this.checkAll = false
            this.getListData()
          } else {
            this.$message.error(res.msgContent)
          }
        })
      })
    },
    // 删除单个数据
    deleteClick (data) {
      this.batchDelete(data)
    },
    // 取消弹窗
    cancelListForm () {
      this.resetListForm()
      this.listFormShow = false
    },
    // 修改名单
    updateClick (data, type) {
      console.log(data)
      this.listFormShow = true
      this.formState = 2
      this.formData.buildingCode = data.buildingCode
      this.formData.belongModelUrl = data.belongModelUrl
      this.formData.buildingName = data.buildingName
      this.formData.fileCode = data.fileCode
      if (data.fileCode) {
        this.fileList.push({ url: this.imgPath(data) })
        this.$nextTick(() => {
          this.addUploadBtnDom = this.$refs.addAvatar.$el.childNodes[1];
          this.addUploadBtnDom.style.display = 'none'
        })
      }
      if (type == 'view') {
        // 视图模式
        this.formState = 3
      }
    },
    // 创建楼层
    createNameList () {
      this.formState = 1
      this.listFormShow = true
      this.$nextTick(() => {
        this.addUploadBtnDom = this.$refs.addAvatar.$el.childNodes[1];
        this.addUploadBtnDom.style.display = 'inline-block'
      })
    },
    // 请求list数据
    getListData () {
      this.listData = []
      this.loading = true
      let params = {
        pageNum: this.pageObj.pageNum,
        pageSize: this.pageObj.pageSize,
        buildingCode: this.$route.query.code,
        pageFlag: true,
        buildingName: this.filterData.name,
        buildingType: 2,//1楼栋2楼层
      }
      this.$fetch(api.queryBuildingList, params).then((res) => {
        this.loading = false
        if (res.success) {
          this.listData = res.returnObj.list
          this.pageObj.total = res.returnObj.total
        } else {
          this.$message.error(res.msgContent)
        }

      })
    },
    // 改变页码
    currentChange (e) {
      this.pageObj.pageNum = e
      this.getListData()
    },
    // 改变pageSize
    sizeChange (e) {
      this.pageObj.pageNum = 1
      this.pageObj.pageSize = e
      this.getListData()
    },
    // 查询
    queryFilter () {
      this.pageObj.pageNum = 1
      this.pageObj.pageSize = 10
      this.getListData()
    },
    // 重置
    resetClick () {
      this.filterData.name = ''
      this.pageObj.pageNum = 1
      this.pageObj.pageSize = 10
      this.getListData()
    },
    beforeAvatarUpload (file) {
      const isImg = ['image/png', 'image/jpg', 'image/jpeg', 'image/bpm'].includes(file.type)
      if (!isImg) this.$message.error('图片类型错误,只能是png/jpg/jpeg/bpm中的一种')
      return isImg
    },
    // 判断上传文件个数
    fileCount (file, fileList) {
      this.$message.warning(this.$t('personMg.message.upWarn'))
    },
    handleSuccess (res, file, fileList) {
      if (res.success) {
        this.formData.fileCode = res.returnObj[0].fileId
      }
    },
    handleExceed (file, fileList) {
      this.$message({
        showClose: false,
        message: this.$t('base.message.fileExceed'),
        type: 'error',
        duration: 2000,
      })
    },
    handleRemove (file, fileList) {
      this.formData.fileCode = ''
      this.fileList = []
      this.addUploadBtnDom.style.display = 'inline-block'
    },
    validImg (file) {
      const fileName = file.name
      const type = fileName.slice(fileName.indexOf('.') + 1, fileName.length)
      const imgArr = ['jpg', 'png', 'jpeg', 'jpe', 'dib', 'bmp', 'JPG', 'PNG', 'JPEG', 'JPE', 'DIB', 'BMP']
      let isJPG = null
      imgArr.indexOf(type) === -1 ? (isJPG = false) : (isJPG = true)

      if (!isJPG) {
        this.$message.error(this.$t('personMg.message.formatWarn'))
        return false
      }
      const Size = 1024 * 1024 * 4
      if (file.size > Size) {
        this.$message.error(this.$t('personMg.message.sizeWarn'))
        return false
      }
      return true
    },
    handleChangeFile (file, fileList) {
      if (!this.addUploadBtnDom) {
        this.addUploadBtnDom = this.$refs.addAvatar.$el.childNodes[1];
      }
      this.addUploadBtnDom.style.display = 'none'
    },
    // 提交添加/修改名单
    submitClick () {
      console.log(this.formData)
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.submitData()
        }
      })
    },
    submitData () {
      this.subBtm = true
      let params = {
        buildingName: this.formData.buildingName,
        fileCode: this.formData.fileCode,
        belongModelUrl: this.formData.belongModelUrl,
        parentCode: this.$route.query.code,
      }
      let url = ''
      this.formState === 1 ? url = api.addBuilding : (
        url = api.updateBuilding, params.buildingCode = this.formData.buildingCode)
      this.$fetch(url, params).then((res) => {
        this.subBtm = false
        if (res.success) {
          this.$message.success("操作成功")
          this.getListData()
          this.cancelListForm()
        } else {
          this.$message.error(res.msgContent)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../style/Index.scss";
@import "~@src/common/assets/style/mixin";
.list-content {
  .list-item {
    width: 31%;
    display: inline-block;
    &:hover {
      .footer-content {
        display: flex !important;
      }
      opacity: 0.8;
      .itemItem {
        color: #fff !important;
      }
    }
    // margin: 0.25% 0.5% 0.25% 0;
    margin: 1%;
    position: relative;
    .imgDiv {
      border-left: 4px solid rgba(233, 78, 78, 1);
      display: flex;
      align-items: cente;
      height: 170px;
      @include set_theme_color(background-color, blur-color-content);
      .itemLeft {
        width: 30%;
        // height: 90px;
        padding: 20px 10px;
        // @include set_theme_color(background-color, blur-color-content);
        .image {
          width: 100%;
          height: 100%;
        }
      }
      .itemRight {
        // flex: 3;
        width: 65%;
        padding: 20px 10px;
        // @include set_theme_color(background-color, blur-color-content);
        .footer-content {
          align-items: flex-end;
          position: absolute;
          right: 5px;
          margin-top: 15px;
          -webkit-flex-flow: row-reverse wrap;
          display: none;
          flex-flow: column;
          flex-wrap: wrap;
          justify-content: space-between;
          // text-align: right;
          // margin: 5px 5px 0 0;
          button {
            margin-top: 12px;
            padding: 5px 13px;
          }
        }
        .itemName {
          font-size: 18px;
          display: grid;
          width: 90%;
          overflow: hidden;
          text-overflow: ellipsis;
          margin: 0px 0 17px 0;
          span {
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .itemItem {
          display: flex;
          font-size: 14px;
          color: rgba(162, 173, 203, 1);
          margin-top: 10px;

          label {
            display: block;
            width: 80%;
          }
          span {
            display: block;
            width: 80%;
            overflow: hidden;
            // white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}
</style>
